var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticStyle: { height: "100%" } },
    [
      _c(
        "v-container",
        {
          staticClass: "pa-0",
          staticStyle: { height: "100%" },
          attrs: { fluid: "", "grid-list-md": "" }
        },
        [
          _c(
            "v-flex",
            { staticStyle: { height: "100%" }, attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "mx-auto contenedor-persona",
                  staticStyle: {
                    height: "100%",
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "space-between"
                  },
                  attrs: { color: "grey lighten-4", elevation: "4" }
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pt-1 pb-0 contenedor-foto" },
                    [
                      _c(
                        "v-avatar",
                        {
                          attrs: {
                            color: _vm.foto ? "#FFF" : "light-blue darken-4",
                            size: "75"
                          }
                        },
                        [
                          _vm.foto
                            ? _c("v-img", {
                                attrs: {
                                  "aspect-ratio": 16 / 9,
                                  src: _vm.foto,
                                  "max-height": "150",
                                  "max-width": "150",
                                  "min-height": "75",
                                  "min-width": "75"
                                },
                                on: {
                                  error: function($event) {
                                    return _vm.handleImageError()
                                  }
                                }
                              })
                            : _c(
                                "span",
                                { staticClass: "white--text display-1" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.persona.nombres.trim()[0] || "-")
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "mt-1 mb-0 pt-0 pb-0 text-xs-center" },
                    [
                      _c(
                        "h4",
                        {
                          staticClass: "font-weight-bold blue--text m-0",
                          staticStyle: { "font-size": "1.1em" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.persona.ap_paterno) +
                              " " +
                              _vm._s(_vm.persona.ap_materno) +
                              "\n            " +
                              _vm._s(_vm.persona.nombres) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "table",
                        { staticClass: "table-datos-personales" },
                        _vm._l(_vm.l_datos_personales, function(dato) {
                          return _c("tr", { key: dato.key }, [
                            _c(
                              "td",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      dark: "",
                                      small: "",
                                      icon: "",
                                      color: "primary",
                                      outline: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "material-symbols-outlined"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(dato.icon) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "titulo-personal font-weight-bold blue--text"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(dato.label) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "subtitulo-personal" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.persona[dato.key]) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "py-0",
                      staticStyle: {
                        "border-top": "0.5px solid rgba(103, 135, 183,0.3)"
                      }
                    },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { slot: "activator", icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.verDetallePersona()
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("fullscreen")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Ver detalles")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebff05d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebff05d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes_lista_personal/components/ItemSliderComponent.vue
// module id = null
// module chunks = 